import React from 'react'
import { Container, Image } from 'react-bootstrap'
import Heading from '../ui/Heading'
import { useTranslation } from 'react-i18next'
const CustomerExperience = () => {
   const { t } = useTranslation();
  return (
    <section className="insta-section section-space pb-0">
      <Container className="home-showcase-container px-0">
        <Heading>
          <h2>{(t('spinosaExperience.heading'))}</h2>
          <p>{(t('spinosaExperience.subheading'))}</p>
        </Heading>

        <div className='image-grid-wrapper'>
          {Array.from({ length: 28 }).map((_, index) => <div className='item'>
            <Image src={require(`../../../../Assets/images/customer/new/${index + 1}.jpg`)} loading="lazy" alt={"Customer"} />
          </div>)}
        </div>
      </Container>
    </section>
  )
}

export default CustomerExperience